import {Component, EventEmitter, inject, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {SearchExecutorService} from '../../object-search/search-executor.service';
import {SearchContainer} from '../../core/definitions/search-container';
import {SearchResultViewType} from '../../core/definitions/search-result-view-type.enum';
import {ResultViewService} from '../../object-search/result-view.service';
import {ContentListContainer} from '../../core/definitions/object-content-tab/content-list-container';

@Component({
    selector: 'app-object-content-list-search-view',
    templateUrl: './object-content-list-search-view.component.html',
    styleUrls: ['./object-content-list-search-view.component.scss'],
    standalone: false
})
export class ObjectContentListSearchViewComponent implements OnChanges, OnDestroy {
  // Injections
  private readonly searchExecutorService: SearchExecutorService = inject(SearchExecutorService);
  private readonly resultViewService: ResultViewService = inject(ResultViewService);

  @Input() contentListContainer: ContentListContainer;
  @Output() objectRefresh = new EventEmitter<any>();

  searchContainer: SearchContainer;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.contentListContainer) {
      this.unsubscribeFromSearchContainer();
      this.searchContainer = this.contentListContainer.searchContainer;
      this.searchExecutorService.subscribeToSearchResult(this.searchContainer, this.checkSetSearchRowsInit);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeFromSearchContainer();
  }

  onObjectRefresh(event) {
    this.objectRefresh.emit(event);
  }

  reloadOverview = (): Promise<void> => {
    return this.searchExecutorService.runSearch(this.searchContainer).then(() => undefined);
  }

  private unsubscribeFromSearchContainer() {
    if (this.searchContainer) {
      this.searchExecutorService.unSubscribeToSearchResult(this.searchContainer, this.checkSetSearchRowsInit);
    }
  }

  private checkSetSearchRowsInit = () => {
    this.checkSetSearchRows();
  }

  private checkSetSearchRows() {
    this.resultViewService.calculateAndSetsDefaultRowsColumns(this.searchContainer);

    const viewName = this.searchContainer.searchResultViewName;
    const cardRows = this.searchContainer.rows?.[SearchResultViewType.CONTENT_LIST];
    if (viewName === SearchResultViewType.LIST && typeof cardRows === 'number') {
      this.searchContainer.rows[viewName] = cardRows;
      return;
    }
    const oldRows = this.searchContainer.rows[viewName];
    const calculatedRows = this.resultViewService.getDefaultCalculatedRowsColumns(viewName).rows;
    let mustSearch = false;
    if (calculatedRows && calculatedRows !== oldRows) {
      mustSearch = true;
      this.searchContainer.rows[viewName] = calculatedRows;
    }
    if (mustSearch && !this.searchContainer.displayAll) {
      this.searchExecutorService.runSearch(this.searchContainer).then();
    }
  }


}
